import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	moreAvatarsCount: {
		id: 'polaris-common.idea-card-v2.body.users.more-avatars-count',
		defaultMessage: '+{count}',
		description: '+X where X is a number of additional users assigned to this people field',
	},
});
